import { render, staticRenderFns } from "./RuleActions.vue?vue&type=template&id=6e26f34e&scoped=true&"
import script from "./RuleActions.vue?vue&type=script&lang=ts&"
export * from "./RuleActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e26f34e",
  null
  
)

export default component.exports